import axiosHttp from "services/axiosHttp";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchOrderTypeList = createAsyncThunk(
  "fetchOrderTypeList",
  async () => {
    const token = localStorage.getItem("auth_token");

    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    const response = await axiosHttp.get(`order/ordertype/list`, config);
    return response.data.data;
  }
);

const orderTypeListSlice = createSlice({
  name: "orderTypeList",
  initialState: {
    isLoading: false,
    data: null,
    error: null,
  },

  extraReducers: (builder) => {
    builder.addCase(fetchOrderTypeList.pending, (state, action) => {
      state.isLoading = true;
    });

    builder.addCase(fetchOrderTypeList.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    });
    builder.addCase(fetchOrderTypeList.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });
  },
});

export default orderTypeListSlice.reducer;
